import { render, staticRenderFns } from "./FileMappingPage.vue?vue&type=template&id=391124ab&"
import script from "./FileMappingPage.vue?vue&type=script&lang=ts&"
export * from "./FileMappingPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports